export default{
    drawerMenuMainContainer: {
        display: 'flex', 
        gap: '25px', 
        flexDirection: 'column'
    },
    drawerMenuItemContainer: {
        display: 'flex', 
        gap: '20px', 
        flexDirection: 'row', 
        alignItems: 'center', 
        cursor:'pointer' 
    },
}